import React from "react";
import "./topicCard.css";
import FavoriteIcon from "../favoriteIcon/favoriteIcon";

const TopicCard = ({
  logo,
  topic,
  onlineCoaches = [],
  availableCoaches = 1,
  topicDescription,
  topicId,
  onClick,
  isFavorited = false,
  favoriteLoading = false,
  onToggleFavorite,
}) => {
  return (
    <div
      className="topic-card-bento"
      onClick={() => onClick && onClick(topicId)}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <FavoriteIcon
        className="topic-card-bento-favorite"
        isFavorited={isFavorited}
        loading={favoriteLoading}
        onToggle={onToggleFavorite}
      />
      <img className="topic-card-bento-img" src={logo} alt={topic} />
      <div className="topic-card-bento-overlay">
        <div className="topic-card-bento-panel">
          <div className="topic-card-bento-header">
            <h3 className="topic-card-bento-title">{topic}</h3>
          </div>
          <div className="topic-card-bento-body">
            <p className="topic-card-bento-desc">
              {topicDescription && topicDescription.length > 80
                ? `${topicDescription.substring(0, 80)}...`
                : topicDescription}
            </p>
            <div className="topic-card-bento-footer">
              <div className="topic-card-bento-coaches">
                <div className="topic-card-bento-avatars">
                  {onlineCoaches.slice(0, 2).map((dp, i) => (
                    <img
                      key={i}
                      className="topic-card-bento-avatar"
                      alt="coach"
                      src={dp}
                    />
                  ))}
                  {availableCoaches > 2 && (
                    <span className="topic-card-bento-coach-count">
                      +{availableCoaches - 2}
                    </span>
                  )}
                </div>
              </div>
              <button className="topic-card-bento-btn">
                Explore
                <span className="topic-card-bento-arrow material-symbols-outlined">
                  arrow_forward
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopicCard;
